import { createSlice } from '@reduxjs/toolkit';

import { requestData } from './Actions';

interface InstanceState {
  data: any[];
  fullData: Record<string, any>;
  loading: boolean;
  error: string | null;
}

interface InstancesState {
  [key: string]: InstanceState;
}

const initialState: InstancesState = {};

const initializeInstanceState = (): InstanceState => ({
  data: [],
  fullData: {},
  loading: false,
  error: null,
});

const instancesSlice = createSlice({
  name: 'instances',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle onLoad
      .addCase(requestData.pending, (state, action) => {
        const { instanceType } = action.meta.arg;
        if (!state[instanceType]) {
          state[instanceType] = initializeInstanceState();
        }
        state[instanceType].loading = true;
        state[instanceType].error = null;
      })
      .addCase(requestData.fulfilled, (state, action) => {
        const { instanceType, data, dataKey = 'items' } = action.payload;
        const responseData = data as Record<string, any>;
        state[instanceType].data = responseData[dataKey] || [];
        state[instanceType].fullData = responseData;
        state[instanceType].loading = false;
      })
      .addCase(requestData.rejected, (state, action) => {
        const { instanceType } = action.meta.arg;
        state[instanceType].loading = false;
        state[instanceType].error = action.payload as string;
      });
  },
});

export default instancesSlice.reducer;
